export default "__VITE_ASSET__BjUJvQdd__"